import { render, staticRenderFns } from "./VServiceTaskTableCell.vue?vue&type=template&id=7024a44b&scoped=true&"
import script from "./VServiceTaskTableCell.vue?vue&type=script&lang=ts&"
export * from "./VServiceTaskTableCell.vue?vue&type=script&lang=ts&"
import style0 from "./VServiceTaskTableCell.vue?vue&type=style&index=0&id=7024a44b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7024a44b",
  null
  
)

export default component.exports